<template>

    <div class="new-list-group-item">
        <div class="row">
            <div class="col-4">
                <div class="tooltip-target">
                    <span v-if="dateIsAfterNow(period.starts_at)">
                        {{ period.starts_at }}
                    </span>
                    <datepicker-new
                        :input-class="{
                            'form-control': true,
                            'form-control-sm': true,
                            'is-invalid': getError('starts_at')
                        }"
                        placeholder="Välj datum"
                        :use-utc="true"
                        :language="former.datepicker.locale"
                        :monday-first="true"
                        :disabled-dates="former.datepicker.disabledDates"
                        :format="formerDateFormat"
                        v-model="period.starts_at"
                        v-if="!dateIsAfterNow(period.starts_at)"
                    />

                    <div class="tooltip-label" v-if="subscription.type === 'binding_period'">
                        Priserna gäller från nästa påbörjade eller förnyade abonnemang (avtal), efter datumet
                        ovan.
                    </div>
                    <div class="tooltip-label" v-if="subscription.type !== 'binding_period'">
                        Priserna börjar gälla direkt på datumet. Inget nytt avtal krävs.
                    </div>
                </div>
            </div>
            <div class="col-6" v-if="subscription.type !== 'pay_per_treatment'">
                <span v-if="period.monthly_cost && dateIsAfterNow(period.starts_at)">
                    {{  period.monthly_cost }} kr
                </span>
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="monthly_cost"
                    v-model="period.monthly_cost"
                    addon=" kr"
                    v-if="!dateIsAfterNow(period.starts_at)"
                    customErrorMessage="Ange månadskostnad"
                />
            </div>
            <div class="col-6" v-if="subscription.type !== 'pay_per_treatment' && subscription.type !== 'unlimited'">
                <span v-if="period.exceeding_treatment_cost && dateIsAfterNow(period.starts_at)">
                    {{  period.exceeding_treatment_cost }} kr
                </span>
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="exceeding_treatment_cost"
                    v-model="period.exceeding_treatment_cost"
                    addon=" kr"
                    v-if="!dateIsAfterNow(period.starts_at)"
                    customErrorMessage="Ange pris för extra behandlingar"
                />
            </div>
            <div class="col-6" v-if="subscription.type === 'pay_per_treatment'">
                <span v-if="period.internal_treatment_cost && dateIsAfterNow(period.starts_at)">
                    {{  period.internal_treatment_cost }} kr
                </span>
                <div v-if="subscription.internal === 1">
                    <input-text
                        type="number"
                        formGroupClass="w-75 mb-0"
                        name="internal_treatment_cost"
                        v-model="period.internal_treatment_cost"
                        addon=" kr"
                        v-if="!dateIsAfterNow(period.starts_at)"
                        customErrorMessage="Ange behandlingspris"
                    />
                </div>
            </div>
            <div class="col-6" v-if="subscription.type === 'pay_per_treatment'">
                <span v-if="period.external_treatment_cost && dateIsAfterNow(period.starts_at)">
                    {{  period.external_treatment_cost }} kr
                </span>
                <div v-if="subscription.external === 1">
                    <input-text
                        type="number"
                        formGroupClass="w-75 mb-0"
                        name="external_treatment_cost"
                        v-model="period.external_treatment_cost"
                        addon=" kr"
                        v-if="!dateIsAfterNow(period.starts_at)"
                        customErrorMessage="Ange behandlingspris"

                    />
                </div>
            </div>
            <div class="col-4" v-if="subscription.external === 1">
                <span v-if="period.monthly_workplace_cost && dateIsAfterNow(period.starts_at)">
                    {{ period.monthly_workplace_cost }} kr
                </span>
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="monthly_workplace_cost"
                    v-model="period.monthly_workplace_cost"
                    addon=" kr"
                    v-if="!dateIsAfterNow(period.starts_at)"
                />
            </div>
            <div class="col-4" v-else></div>
            <div class="col d-flex justify-content-end">
                <button class="btn btn-primary btn-sm mr-2" v-if="!dateIsAfterNow(period.starts_at)" :disabled="patcher.submitted" @click="patcherPatch()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Spara ändringar
                    <div class="tooltip-label">Du kan ändra datum och priser fram till att datumet passerats. Då
                        går det inte längre att göra ändringar. Lägg i så fall till en ny period månaden efter.
                    </div>
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import moment from 'moment'

import patcher from '../../../../shared/mixins/patcher'

export default {

    mixins: [
        patcher
    ],

    props: {
        untouchedPeriod: {
            required: true
        },
        subscription: {
            required: true
        }
    },

    data () {
        return {
            period: {
                starts_at: this.untouchedPeriod.starts_at,
                monthly_cost: this.untouchedPeriod.monthly_cost,
                exceeding_treatment_cost: this.untouchedPeriod.exceeding_treatment_cost,
                internal_treatment_cost: this.untouchedPeriod.internal_treatment_cost,
                external_treatment_cost: this.untouchedPeriod.external_treatment_cost,
                monthly_workplace_cost: this.untouchedPeriod.monthly_workplace_cost
            },
            former: {
                datepicker: {
                    disabledDates: {
                        customPredictor: function (date) {
                            if (date.getDate() !== 1) {
                                return true
                            }
                        }
                    }
                }
            }
        }
    },

    computed: {
        patcherUrl () {
            return '/subscriptions/' + this.subscription.id + '/pricePeriods/' + this.untouchedPeriod.id
        },
        patcherData () {
            return this.period
        }
    },

    methods: {
        dateIsAfterNow (date) {
            return moment().isAfter(date)
        },

        patcherSuccess () {
            bus.$emit('notify', 'Ändringarna har sparats.')
            this.$emit('refresh')
        }
    }
}
</script>
